import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class TrendIntensityTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const tiiValue = currentItem && yAccessor(currentItem);

    const tii =
      (tiiValue && tiiValue.tii != null && displayFormat(tiiValue.tii)) ||
      "n/a";
    const signal =
      (tiiValue && tiiValue.signal != null && displayFormat(tiiValue.signal)) ||
      "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    const tiiColor = appearance?.strokeTII?.color || "#8884d8";
    const signalColor = appearance?.strokeSignal?.color || "#FF0000";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-trend-intensity"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>TII (</ToolTipTSpanLabel>
          <tspan fill={labelFill}>{options?.period || 14}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={tiiColor}>{tii}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Sinal (</ToolTipTSpanLabel>
          <tspan fill={signalColor}>{options?.signalPeriod || 9}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>): </ToolTipTSpanLabel>
          <tspan fill={signalColor}>{signal}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

TrendIntensityTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  options: PropTypes.object,
  appearance: PropTypes.object,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};

TrendIntensityTooltip.defaultProps = {
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  labelFill: "#4a4a4a",
  fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
  fontSize: 12,
};

export default TrendIntensityTooltip;
